import { render } from "./SimDetailsModal.vue?vue&type=template&id=41b72ed4&scoped=true"
import script from "./SimDetailsModal.vue?vue&type=script&lang=js"
export * from "./SimDetailsModal.vue?vue&type=script&lang=js"

import "./SimDetailsModal.vue?vue&type=style&index=0&id=41b72ed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b72ed4"]])

export default __exports__